/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;



//////////////////
// WEBPACK FOOTER
// ./~/react-quill/~/lodash/stubFalse.js
// module id = 1238
// module chunks = 0